import { useEffect } from "react";
import { useLocation } from "react-router-dom";

import { routers } from "@/configs";

const FADE_MS = 200;

/** Fades out the static skeleton from index.html; it stays over the app until then. */
export const hideBootShell = () => {
  const shell = document.getElementById("boot-shell");
  if (!shell || shell.classList.contains("bs-leaving")) return;
  shell.classList.add("bs-leaving");
  // A timer, not transitionend: a reduced-motion player has no transition to end.
  window.setTimeout(() => shell.remove(), FADE_MS);
};

/**
 * Goes inside a layout's Suspense, beside its Outlet: its effect waits for the page's chunk, so a
 * reload goes from the boot skeleton straight to the page, without PageFallback's shape in between.
 */
export const BootShellExit = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // "/" only redirects to the lobby, whose chunk is still on its way: the column would stand empty.
    if (pathname !== routers.Home) hideBootShell();
  }, [pathname]);

  return null;
};
